/**
 * 距离测量类型
 */
export enum MapDistanceSearchType {
  /**
   * 直线距离
   */
  DistanceSearchTypeStraight = 0,
  /**
   * 驾车导航距离
   */
  DistanceSearchTypeDrive = 1,
  /**
   * 步行导航距离
   */
  DistanceSearchTypeWalk = 3,
}
